import { render, staticRenderFns } from "./TextEditor.vue?vue&type=template&id=3a6c793c&scoped=true&"
import script from "./TextEditor.vue?vue&type=script&lang=ts&"
export * from "./TextEditor.vue?vue&type=script&lang=ts&"
import style0 from "./TextEditor.vue?vue&type=style&index=0&id=3a6c793c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6c793c",
  null
  
)

export default component.exports